<template>
  <div class="date-picker d-flex align-center">
    <div class="move prev d-flex align-center justify-center" @click="move(-1)">
      <ChevronIcon class="arrow" size="24" />
    </div>
    <div v-resize="onResize" class="date-list flex-grow-1" ref="dateList">
      <div
        v-for="date in dateList"
        :key="date"
        class="card"
        :class="{ selected: date === selected }"
        @click="$emit('change', toDateKey(date))"
      >
        <div class="date">{{ $d(date, 'shortDate') }} ({{ $d(date, 'day') }})</div>
      </div>
    </div>
    <div class="move next d-flex align-center justify-center" @click="move(1)">
      <ChevronIcon size="24" class="arrow" />
    </div>
  </div>
</template>

<script>
import ChevronIcon from "@/components/icons/ChevronIcon.vue";
import { formatDate } from "@/plugins/i18n";

export function toDateKey(date) {
  return formatDate(date, "yyyy-mm-dd");
}

export function addDate(date, value) {
  date = new Date(date);
  date.setDate(date.getDate() + value);
  return date;
}

export function nextDateKey(date = null) {
  date = date ? new Date(date) : new Date();
  return toDateKey(date);
}

export default {
  model: {
    prop: "selected",
    event: "change"
  },

  components: {
    ChevronIcon
  },

  props: {
    selected: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      centerDate: nextDateKey(this.selected),
      length: 1
    };
  },

  computed: {
    dateList() {
      const list = [this.centerDate];
      let date1 = this.centerDate;
      let date2 = this.centerDate;

      for (let i = 0; i < this.length; i++) {
        list.push(date1 = nextDateKey(addDate(date1, 1)));
        list.unshift(date2 = nextDateKey(addDate(date2, -1)));
      }

      return list;
    }
  },

  methods: {
    onResize() {
      const width = this.$refs.dateList.offsetWidth;
      let i = 1;
      while (width > (i * 2 + 1) * 150) i++;
      this.length = i;
    },

    toDateKey,

    move(step) {
      this.centerDate = nextDateKey(addDate(this.centerDate, step));
    }
  },
};
</script>

<style lang="scss" scoped>
.date-picker {
  padding: 0 16px;
  user-select: none;

  @media screen and (max-width: 960px) {
    padding: 0;
  }
}

.date-list {
  margin: 0 8px;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  grid-gap: 5px;
}

.card {
  background-color: #fff;
  border-radius: 3px;
  padding: 12px;
  text-align: center;
  color: #555;
  cursor: pointer;
  box-shadow: 0px 3px 6px #00000029;

  &.selected {
    color: #fff;
    font-weight: bold;
    background-color: #007E57;
  }
}

.day {
  background-color: #F5F5F5;
  border-radius: 3px;
  font-size: 12px;
  line-height: 18px;
  color: #777;
  margin-bottom: 4px;

  @media screen and (max-width: 960px) {
    font-size: 14px;
    line-height: 24px;
  }

  .selected & {
    background-color: #339879;
    color: #fff;
  }
}

.date {
  font-size: 18px;
  line-height: 28px;

  @media screen and (max-width: 960px) {
    font-size: 16px;
    line-height: 20px;
  }
}

.move {
  width: 20px;
  height: 50px;
  fill: #333;
  cursor: pointer;

  &.prev .arrow {
    transform: scaleX(-1);
  }

  @media screen and (max-width: 960px) {
    width: 26px;
    height: 56px;
  }
}
</style>
